import prefixNamespace from '@/utils/prefix-namespace'
import { storeKeyNameSpace } from '@/constants/stores'

export const _types = {
    getters: {
        GET_STORE: 'getStore',
        GET_TOKEN: 'getToken',
        GET_CHANNELS: 'getChannels',
        GET_APP_PUSHER: 'getAppPusher',
    },
    actions: {
        GET_STORE: 'getStore',
        LOGIN: 'login',
        SHOPIFY_LOGIN: 'shopifyLogin',
        LOGOUT: 'logout',
        INIT_LINEBASE: 'initLineBase',
        INIT_CRISP_CHAT: 'initCrispChat',
        INIT_INTERCOM: 'initIntercom',
        DESTROY_INTERCOM: 'destroyIntercom',
        TOGGLE_SHOW_INTERCOM: 'toggleShowIntercom',
        SHOW_INTERCOM: 'showIntercom',
        HIDE_RATING_BAR: 'hideRatingBar',
        INIT_PUSHER: 'initPusher',
    },
    mutations: {
        LOGOUT: 'logout',
        SET_TOKEN: 'setToken',
        REMOVE_TOKEN: 'removeToken',
        SET_STORE: 'setStore',
        SET_CHANNELS: 'setChannels',
        SET_APP_PUSHER: 'setAppPusher',

    }
}

export const types = prefixNamespace(`${storeKeyNameSpace.AUTH}/`, _types)